/**
 * Determines if a field value has been updated
 * Field existed and value changed = "Updated"
 */
export const isFieldUpdated = (currentValue: string | undefined, newValue: string): boolean => {
    return currentValue !== undefined && currentValue !== '' && currentValue !== newValue;
};

/**
 * Determines if a field is new (didn't exist before)
 * Field didn't exist before = "New"
 */
export const isFieldNew = (currentValue: string | undefined, newValue: string): boolean => {
    return (currentValue === undefined || currentValue === '') && newValue !== '';
};

/**
 * Formats a value for display, returning '--' for empty/undefined values
 */
export const formatValue = (value: string | undefined): string => {
    return value && value !== '' ? value : '--';
};
